








































































// vendor
import { isNumber } from 'util';
import { defineComponent, PropType, computed } from "@vue/composition-api";
// local
import MillisecondInput from "../widgets/ms-input.vue";
import NumberDropdown from "../widgets/number-dropdown.vue";
import LinearSlider from "../widgets/linear-slider.vue";
import { SARTParameters } from "../../ts/types/SARTParameters";

export default defineComponent({
	components:{
		MillisecondInput,
		NumberDropdown,
		LinearSlider
	},
	props:{
		parameters:{
			type:Object as PropType<SARTParameters>,
			required:true
		}
	},
	setup(props){

		const conformatStimulus = (v:any) => {
			if(isNaN(v)){
				return props.parameters.stimulus;
			}
			const n = Number(v);
			return n < 0 || n > 1 ? props.parameters.stimulus : n;
		};

		const formatValues = (v:any) => {
			if(isNaN(v)){
				return props.parameters.values;
			}
			const n = Number(v);
			return n < 0 ? props.parameters.values : n;
		};

		const formatDisplayTime = (v:any) => {
			if(isNaN(v)){
				return props.parameters.displayTime;
			}
			const n = Number(v);
			return n < 0 ? props.parameters.displayTime : n;
		};

		const formatPauseTime = (v:any) => {
			if(isNaN(v)){
				return props.parameters.pause;
			}
			const n = Number(v);
			return n < 0 ? props.parameters.pause : n;
		};

		return {
			conformatStimulus,
			formatValues,
			formatDisplayTime,
			formatPauseTime
		};
	}
});
